
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/orders",
      function () {
        return require("private-next-pages/account/orders.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/orders"])
      });
    }
  